import {
    Box,
    useTheme,
    Typography,
    Switch,
    Button,
    TextField,
    useMediaQuery,
    FormControl,
    Select,
    MenuItem,
    FormControlLabel,
    Checkbox,
} from "@mui/material";
import logo from "../../assets/buzz.png";
// import mark from "../../assets/mark.jpg";
import enabledlocation from "../../assets/enabledlocation.svg";
import male from "../../assets/maleinstant.svg";
import { width } from "@mui/system";

import {
    GoogleMap,
    InfoWindow,
    InfoWindowF,
    Marker,
    MarkerF,
    useLoadScript,
} from "@react-google-maps/api";
import React, { useMemo, useState, useEffect, useRef } from "react";
import { json, Link, useLocation, useNavigate } from "react-router-dom";
import { tokens } from "../../Theme/theme";
import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { Header } from "../global/Header";
import { Add, AddCircleOutline, AddOutlined, ArrowBackIos, ArrowBackIosNewRounded, ArrowDownwardRounded, ArrowRight, ArrowRightAltRounded, ArrowRightOutlined, CameraAltOutlined, CloseOutlined, CloseSharp, ContentCopy, Done, ExitToAppOutlined, KeyboardArrowRight, PersonSearchOutlined, Send, Shield } from "@mui/icons-material";
import '../Users/MapStyle.css'
import BASE_URL from "../../NetworkConfig/ApiConfig";
import CreateCommunityPopup from "../Utils/CreateCommunityPopup";
import AddUsersPopup from "../Utils/AddUsersPopup";
import searchIcon from '../../assets/search.svg'
import { MoonLoader } from 'react-spinners'
import AddEventPopup from "../Utils/AddEventPopup";
import SelectCommunitiesPopup from "../Utils/SelectCommunitiesPopup";
import ApplicationUserSearchPopup from "../Utils/ApplicationUserSearchPopup";



function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const AddJobApplicationScreen = () => {


    return <CommunityListView />;
};
const Convert_Time_Zone = (isostring) => {
    const isoString = isostring;
    const desiredFormat = "dd MMM, hh:mm a";

    const indianTimeZone = "Asia/Kolkata";
    const zonedTime = utcToZonedTime(isoString, indianTimeZone);

    const formattedDate = format(zonedTime, desiredFormat, {
        timeZone: indianTimeZone,
    });
    return formattedDate;
};
function CommunityListView({ data }) {
    const [userProfile, setUserProfile] = useState({})
    const navigate = useNavigate();
    const query = useQuery()
    const [additinalQuestions, setAdditionalQuestions] = useState([])
    const [jobDetails, setJobDetails] = useState({})
    const [loading, setLoading] = useState(false)
    const [totalApplicants, setTotalApplicants] = useState(0)
    const [showSearchPopup, setShowSearchPopup] = useState(false)
    const theme = useTheme();
    const [selectedJobItem, setSelectedJobItem] = useState({})
    const [answers, setAnswers] = useState([]);
    const [selectedDate, setSelectedDate] = useState(null);


    useEffect(() => {
        getJobDetails()
        getJobRegistrations()
    }, []);


    const getJobDetails = async () => {
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/jobs/get-job-data-metrics/${query.get("ref")}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        console.log(data)
        if (data.success === true) {
            setJobDetails(data.response)
            setAdditionalQuestions(data.response.questions)
        } else {
            alert(data.response)
        }

    };

    const getJobRegistrations = async (page) => {

        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/jobs/get-job-registrations/${query.get("ref")}?page=${1}&limit=${1}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setTotalApplicants(data.pagination?.total ?? 0)
        }

    };


    const submitApplication = async (responses) => {

        try {
            setLoading(true)
            const token = localStorage.getItem("token");
            const response = await fetch(`${BASE_URL}/jobs/add-application`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": token,
                },
                body: JSON.stringify({
                    jobId: query.get("ref"),
                    responses: responses,
                    userId: selectedJobItem?.user?._id ?? selectedJobItem?.userId?._id ?? "",
                    ...selectedDate ? { date: selectedDate } : {}
                })
            });
            const data = await response.json();
            if (data.success === true) {
                alert(data.response)
                getJobRegistrations()
            } else {
                alert(data.response)
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
            alert("Something went wrong")
        }

    };



    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:1200px)')


    const copyToClipboard = async (text) => {
        await navigator.clipboard.writeText(text);
    };

    const handleDateChange = (e) => {
        const { value } = e.target;
        //console.log("------", value)
        setSelectedDate(value);
        //const date = Convet_Date_To_Supported_Date(value)
        //FetchActivityDataByDate(value)
    };

    const ItemJobApplications = ({ item, index }) => {


        const [cIcon, setCIcon] = useState(0)
        const [cIconIdx, setCIconIdx] = useState(-1)

        useEffect(() => {

            if (cIcon == 1) {
                setTimeout(() => {
                    setCIcon(0)
                    setCIconIdx(-1)
                }, 2000);
            }

        }, [cIcon])


        return (
            <Box sx={{
                flexDirection: "column", display: "flex", alignSelf: "stretch", marginInline: "0px",
                background: "#ffffff08", borderRadius: "15px", px: "15px",
                py: "15px", marginBottom: "5px"
            }}>

                <Box sx={{ flexDirection: "row", alignItems: "center", display: "flex" }}>

                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img
                            alt="profile-user"
                            width="35px"
                            height="35px"
                            src={`${item?.user?.image?.[0] ?? ""}`}
                            style={{
                                cursor: "pointer", objectFit: 'cover',
                                borderRadius: "50%",
                                border: "3px solid #ffffff10"
                            }}
                        />
                    </Box>
                    <Box sx={{ ml: "10px", mr: "20px", display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1 }}>

                        <Typography color={"#ffffff"}
                            fontFamily={"poppins-reg"}
                            fontSize={"13px"} style={{ maxLines: 1, textOverflow: 'ellipsis', }} >{item?.user?.full_name ?? ""}</Typography>

                        <Box sx={{
                            display: 'flex', flexDirection: "row", alignItems: 'center',
                            gap: "5px"
                        }}>
                            <Typography color={"#ffffff90"}
                                fontFamily={"poppins-reg"}
                                style={{
                                }}
                                fontSize={"10.5px"}>{item?.user?.buzz_name}</Typography>
                        </Box>

                    </Box>

                </Box>
                <Typography
                    color={"#ffffffff"}
                    fontFamily={"poppins-reg"}
                    fontSize={"12px"}
                    style={{
                        borderRadius: "4px",
                        background: "#ffffff10",
                        paddingTop: "3px",
                        paddingBottom: "3px",
                        marginTop: "10px",
                        paddingLeft: "8px",
                        paddingRight: "8px",

                        alignSelf: "flex-start",
                        maxWidth: "100%",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"
                    }}
                >
                    {item?.job?.title ?? ""}
                </Typography>



                {
                    item?.response?.map((itm, idx) => (
                        <Box sx={{
                            flexDirection: "row", alignItems: "center", display: "flex", alignSelf: "stretch", marginTop: "10px",
                            border: "0px solid #aaaaaa10", background: "#00000050", borderRadius: "15px", px: "10px", py: "10px", position: "relative",
                        }}>

                            <Box sx={{ flexDirection: "column", display: "flex", flex: 1, wordWrap: "break-word", }}>

                                <Typography color={"#ffffff90"}
                                    fontFamily={"poppins-reg"}
                                    style={{
                                        userSelect: "none", msUserSelect: "none", MozUserSelect: "none"
                                    }}
                                    fontSize={"11.5px"}>{item?.job?.questions?.[idx]?.question ?? `Question ${idx + 1}`}</Typography>

                                <Typography color={itm?.answer ? "#ffffff" : "#ad6bfd"}
                                    fontFamily={"poppins-reg"}
                                    style={{
                                        alignSelf: "stretch",
                                        wordWrap: "break-word",
                                        wordBreak: "break-word"
                                    }}
                                    fontSize={"12.5px"}>{itm?.answer ? itm?.answer : "NA"}</Typography>

                            </Box>

                            {
                                itm?.answer && (
                                    <Box
                                        onClick={() => {
                                            copyToClipboard(itm?.answer)
                                            setCIcon(1)
                                            setCIconIdx(idx)
                                        }}
                                        sx={{
                                            width: "40px", height: "40px", borderRadius: "10px", background: "#ffffff10", alignItems: "center", justifyContent: "center",
                                            display: "flex", cursor: "pointer"
                                        }} >

                                        {
                                            cIcon == 1 && cIconIdx == idx ? (
                                                <Done style={{ fontSize: "18px", color: "#ffffff", alignSelf: "center" }} />
                                            ) : (
                                                <ContentCopy style={{ fontSize: "18px", color: "#ffffff", alignSelf: "center" }} />
                                            )
                                        }

                                    </Box>
                                )
                            }


                        </Box>
                    ))
                }


            </Box>
        )

    }

    const ItemSAApplications = ({ item, index }) => {

        const [showAnswers, setShowAnswers] = useState(true)
        const [cIcon, setCIcon] = useState(0)
        const [cIconIdx, setCIconIdx] = useState(-1)

        useEffect(() => {

            if (cIcon == 1) {
                setTimeout(() => {
                    setCIcon(0)
                    setCIconIdx(-1)
                }, 2000);
            }

        }, [cIcon])

        return (
            <Box sx={{
                flexDirection: "column", display: "flex", alignSelf: "stretch", 
                background: "#ffffff08", borderRadius: "15px", px: "15px",
                py: "15px", marginBottom: "5px"
            }}>

                <Box sx={{ flexDirection: "row", alignItems: "center", display: "flex" }}>

                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img
                            alt="profile-user"
                            width="35px"
                            height="35px"
                            src={`${item?.userId?.image?.[0] ?? ""}`}
                            style={{
                                cursor: "pointer", objectFit: 'cover',
                                borderRadius: "50%",
                                border: "3px solid #ffffff10"
                            }}
                        />
                    </Box>
                    <Box sx={{ ml: "10px", mr: "20px", display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1 }}>

                        <Typography color={"#ffffff"}
                            fontFamily={"poppins-reg"}
                            fontSize={"13px"} style={{ maxLines: 1, textOverflow: 'ellipsis', }} >{item?.userId?.full_name ?? ""}</Typography>

                        <Box sx={{
                            display: 'flex', flexDirection: "row", alignItems: 'center',
                            gap: "5px"
                        }}>
                            <Typography color={"#ffffff90"}
                                fontFamily={"poppins-reg"}
                                style={{
                                }}
                                fontSize={"10.5px"}>{item?.userId?.buzz_name}</Typography>
                        </Box>
                    </Box>


                </Box>



                {
                    showAnswers && [
                        { question: "Full Name", answer: item?.full_name, showCopy: true },
                        { question: "Email Address", answer: item?.email, showCopy: true },
                        { question: "Mobile Number", answer: item?.mobileNumber, showCopy: true },
                        { question: "Resume", answer: item?.resume?.url ?? "", showCopy: true },
                        { question: "Preferred Domains", answer: item.preferredDomains },
                        { question: "Total Experience", answer: item?.totalExperience, showCopy: true },
                        { question: "Availability", answer: item?.availability, showCopy: true },
                        { question: "Can Relocate", answer: item?.canRelocate ? "Yes" : "No" },
                        { question: "Portfolio Link", answer: item?.portfolio ?? "", showCopy: true }
                    ].map((itm, idx) => (
                        <Box sx={{
                            flexDirection: "row", display: "flex", alignSelf: "stretch", marginTop: "10px",
                            border: "1.5px solid #aaaaaa20", borderRadius: "15px", px: "10px", py: "10px", position: "relative",
                            wordWrap: "break-word", alignItems: "center"
                        }}>

                            <Box sx={{ display: "flex", flexDirection: "column", flex: 1, wordWrap: "break-word" }}>

                                <Typography color={"#ffffff90"}
                                    fontFamily={"poppins-reg"}
                                    style={{
                                        userSelect: "none", msUserSelect: "none", MozUserSelect: "none"
                                    }}
                                    fontSize={"11.5px"}>{itm?.question ?? `Question ${idx + 1}`}</Typography>

                                {
                                    itm.answer && Array.isArray(itm.answer) && (
                                        <Box sx={{ flexDirection: "row", alignSelf: "stretch", display: "flex", flexWrap: "wrap", gap: "5px", marginTop: "5px" }} >

                                            {
                                                itm?.answer.map((ans, idxx) => (
                                                    <Box sx={{
                                                        px: "10px", py: "5px", alignItems: "center", justifyContent: "center", display: "flex",
                                                        background: "#ad6bfd10", border: "1px solid #ad6bfd20", borderRadius: "5px"
                                                    }}>
                                                        <Typography color={"#ad6bfd"}
                                                            fontFamily={"poppins-reg"}
                                                            style={{
                                                                alignSelf: "stretch"
                                                            }}
                                                            fontSize={"12.5px"}>{ans}</Typography>


                                                    </Box>
                                                ))
                                            }

                                        </Box>
                                    )
                                }

                                {
                                    !Array.isArray(itm.answer) && (
                                        <Typography color={itm?.answer ? "#ffffff" : "#ad6bfd"}
                                            fontFamily={"poppins-reg"}
                                            style={{
                                                alignSelf: "stretch",
                                                wordBreak: "break-word"
                                            }}
                                            fontSize={"12.5px"}>{itm?.answer ? itm?.answer : "NA"}</Typography>

                                    )
                                }

                            </Box>


                            {
                                itm?.answer && itm?.showCopy && (
                                    <Box
                                        onClick={() => {
                                            copyToClipboard(itm?.answer)
                                            setCIcon(1)
                                            setCIconIdx(idx)
                                        }}
                                        sx={{
                                            width: "40px", height: "40px", borderRadius: "10px", background: "#ffffff10", alignItems: "center", justifyContent: "center",
                                            display: "flex", cursor: "pointer"
                                        }} >

                                        {
                                            cIcon == 1 && cIconIdx == idx ? (
                                                <Done style={{ fontSize: "18px", color: "#ffffff", alignSelf: "center" }} />
                                            ) : (
                                                <ContentCopy style={{ fontSize: "18px", color: "#ffffff", alignSelf: "center" }} />
                                            )
                                        }

                                    </Box>
                                )
                            }



                        </Box>
                    ))
                }


            </Box>
        )

    }

    const now = new Date();
    const currentDateTime = new Date(
        now.getTime() - now.getTimezoneOffset() * 60000
    )
        .toISOString()
        .slice(0, 16);


    return (
        <>
            <Box m={"20px"} flexDirection={'column'} display={'flex'}>

                <Box
                    display={"flex"}
                    justifyContent="space-between"
                    alignItems={"center"}
                    sx={{ flexWrap: 'wrap', flexDirection: 'row', gap: "10px" }}
                >
                    <Header
                        title={`Add Applications`}
                        subtitle={`Automatically add applications to the right job using smart apply.`}
                    />

                </Box>

                <Box sx={{ flexDirection: "row", alignItems: "flex-start", display: "flex", flexWrap: "wrap", gap: "10px" }}>

                    <Box sx={{
                        flexDirection: "column", width: (isMobileScreen) ? "100%" : isTabScreen ? "60%" : "40%", gap: "10px", display: "flex",
                        px: '20px',
                        py: '20px',
                        borderRadius: "15px",
                        background: "#ffffff08",
                    }} >


                        <Box
                            display="flex"
                            sx={{
                                fontFamily: "poppins-reg",
                                flexDirection: "column",
                                display: "flex",
                                alignSelf: "stretch",
                            }}>

                            <Typography sx={{ fontSize: "17px", fontFamily: "poppins-mid", color: "#ffffff", maxWidth: "70%" }} >{jobDetails?.title ?? ""}</Typography>

                            <Typography sx={{
                                fontSize: "13px", color: "#ffffff90", maxWidth: "70%", fontFamily: "poppins-reg",
                                marginTop: "3px",
                            }} >By {jobDetails?.club ? jobDetails?.club?.title : jobDetails?.creator?.full_name ?? ""} • {totalApplicants} Applications</Typography>

                        </Box>

                        <Box sx={{ alignSelf: "stretch", height: "1px", background: "#aaaaaa10", my: "10px" }} />

                        <Box sx={{ flexDirection: "row", display: "flex", alignItems: "center" }} >
                            <Box sx={{ flexDirection: "column", flex: 1, display: "flex" }}>
                                <Typography sx={{
                                    fontSize: "15px", color: "#ffffff", fontFamily: "poppins-reg",
                                }} >Find Available Applications</Typography>

                            </Box>


                            <Box
                                onClick={() => setShowSearchPopup(true)}
                                sx={{
                                    cursor: "pointer", userSelect: "none", msUserSelect: "none", MozUserSelect: "none", WebkitUserSelect: "none",
                                    background: "#ffffff08", borderRadius: "10px",
                                    py: "8px", px: "18px", border: "1px solid #ffffff10", display: "flex", gap: "5px", flexDirection: "row", alignItems: "center"
                                }}>
                                <PersonSearchOutlined />
                                <Typography sx={{
                                    fontSize: "15px", color: "#ffffff", fontFamily: "poppins-reg",
                                }} >Select User</Typography>
                            </Box>

                        </Box>


                        {
                            selectedJobItem._id && selectedJobItem?.type == "Application" && (
                                <ItemJobApplications item={selectedJobItem} index={0} />

                            )
                        }

                        {
                            selectedJobItem._id && selectedJobItem?.type == "SmartApply" && (
                                <ItemSAApplications item={selectedJobItem} index={0} />

                            )
                        }




                    </Box>

                    <Box
                        display="flex"
                        sx={{
                            px: '20px',
                            py: '20px',
                            borderRadius: "15px",
                            background: "#ffffff08",
                            width: (isMobileScreen) ? "100%" : isTabScreen ? "60%" : "40%",

                        }}
                        flexDirection={'column'}
                    >

                        <Typography sx={{
                            fontSize: "15px", color: "#ffffff", fontFamily: "poppins-reg",
                        }} >Add Application Details</Typography>

                        <Box sx={{ alignSelf: "stretch", height: "1px", background: "#aaaaaa10", mt: "10px", mb: "15px" }} />

                        {
                            additinalQuestions.map((item, index) => (
                                <Box sx={{ flexDirection: "column", alignSelf: "stretch", display: "flex", marginBottom: "10px" }}>

                                    <Typography sx={{
                                        fontSize: "14px", color: "#ffffff", fontFamily: "poppins-reg",
                                        marginInline: "4px"
                                    }} >{item?.question ?? "Untitled Question"}</Typography>

                                    <Box sx={{
                                        flexDirection: 'row',
                                        backgroundColor: "#ffffff10",
                                        display: 'flex',
                                        mt: "3px",
                                        borderRadius: "15px",
                                        border: "1px solid #ffffff10",
                                        background: "#00000050"
                                    }}>

                                        <textarea placeholder={""}
                                            rows={2}
                                            value={
                                                answers.find(a => a.questionId === item._id)?.answer || ""
                                            }
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                setAnswers((prev) => {
                                                    const exists = prev.find(
                                                        a => a.questionId === item._id
                                                    );

                                                    if (exists) {
                                                        return prev.map((a) =>
                                                            a.questionId === item._id
                                                                ? { ...a, answer: value }
                                                                : a
                                                        );
                                                    }

                                                    return [
                                                        ...prev,
                                                        {
                                                            questionId: item._id,
                                                            answer: value
                                                        }
                                                    ];
                                                });
                                            }}
                                            style={{
                                                outline: 'none',
                                                backgroundColor: "#aaaaaa00",
                                                borderWidth: 0,
                                                paddingLeft: "15px",
                                                paddingRight: "15px",
                                                paddingTop: "12px",
                                                flex: 1,
                                                display: 'flex',
                                                fontSize: "15px",
                                                paddingBottom: "12px",
                                                fontFamily: 'poppins-reg',
                                                color: "white"
                                            }} />



                                    </Box>

                                </Box>
                            ))
                        }

                        <Typography sx={{
                            fontSize: "14px", color: "#ffffff", fontFamily: "poppins-reg",
                            marginInline: "4px",
                            marginBottom: "5px"
                        }} >{"Application Date"}</Typography>

                        <input
                            type={"datetime-local"}
                            name=""
                            id=""
                            max={currentDateTime}
                            value={selectedDate}
                            onChange={handleDateChange}
                            style={{
                                paddingLeft: "10px", paddingTop: '8px',
                                paddingRight: "10px", paddingBottom: '8px',
                                fontFamily: 'poppins-reg',
                                backgroundColor: "#ffffff00",
                                border: '1.5px solid #ffffff10',
                                color: '#ffffff',
                                borderRadius: '10px',
                                alignSelf: "flex-start",
                                outline: 'none',
                                fontSize: "13px"
                            }}
                        />


                        <Box
                            onClick={() => {

                                if (!loading) {
                                    const responses = answers.map((a, i) => {
                                        return {
                                            questionId: a.questionId,
                                            answer: a.answer ?? "",
                                            ...selectedDate ? { createdAt: selectedDate } : {}
                                        }
                                    })

                                    if (!selectedJobItem?._id) {
                                        alert("Please select a user first")
                                    } else if (responses.length == 0 || responses.some(r => r.answer == "")) {
                                        alert("Some of the input fields are empty, please enter all the fields.")
                                    } else {
                                        submitApplication(responses)
                                    }
                                }
                            }}
                            sx={{
                                flexDirection: "row", display: "flex", backgroundColor: "#943bff",
                                borderRadius: "100px", border: "1px solid #aaaaaa15", px: "10px", mt: "40px",
                                cursor: "pointer", minHeight: "50px",
                                py: "15px", position: "relative", alignItems: "center", justifyContent: "center", gap: "5px"
                            }}>

                            {
                                !loading && (
                                    <Box sx={{ flexDirection: "row", display: "flex", alignItems: "center", gap: "5px", justifyContent: "center" }}>
                                        <Typography style={{
                                            fontSize: "14px",
                                            fontFamily: "poppins-reg", color: "#ffffff",
                                        }}>Add to Applications</Typography>

                                    </Box>
                                )
                            }


                            {
                                loading && (
                                    <Box sx={{ position: "absolute" }}>
                                        <MoonLoader size={"20px"} color={"#ffffff"} />
                                    </Box>
                                )
                            }

                        </Box>


                    </Box>

                </Box>


                <ApplicationUserSearchPopup
                    open={showSearchPopup}
                    onClose={() => {
                        setShowSearchPopup(false)
                    }}

                    onSelect={(item) => {
                        setSelectedJobItem({
                            ...item,
                            type: item.response ? "Application" : 'SmartApply'
                        })
                        setAnswers([])
                    }}
                />

            </Box >
        </>
    );
}

export default AddJobApplicationScreen;
